<template>
  <div class="sidebar-container">
    <el-menu
        class="sidebar"
        :default-active="defaultActive"
        :router="true"
        :collapse="isCollapsed"
        :collapse-transition="true"
    >
      <el-menu-item>
        <el-image :src="require('@/assets/images/logo.png')"></el-image>
      </el-menu-item>

      <el-menu-item>
        <!-- 收放控制按钮 -->
        <div @click="toggleSidebar">
          <i class="el-icon-s-fold" v-if="!isCollapsed"></i>
          <i class="el-icon-s-unfold" v-else></i>
        </div>
      </el-menu-item>
      <el-submenu index="0-4">
        <template slot="title">
          <el-image class="menu-image" :src="require('@/assets/images/yonghu.png')"></el-image>
          <span slot="title">個人資料</span>
        </template>
        <el-menu-item index="/personalInformation">個人資料</el-menu-item>
        <el-menu-item @click="logout">登出</el-menu-item>
      </el-submenu>
      <!-- 平台用户 -->
      <el-menu-item v-if="userInfoRoleRoleId == siteAdminRoleId" index="/user">
        <el-image class="menu-image" :src="require('@/assets/images/user-menu.png')"></el-image>
        <span slot="title">平台用戶</span>
      </el-menu-item>

      <!-- 职员 -->
      <el-menu-item v-if="userInfoRoleRoleId == siteAdminRoleId" index="/staff">
        <el-image class="menu-image" :src="require('@/assets/images/staff-menu.png')"></el-image>
        <span slot="title">職員</span>
      </el-menu-item>

      <!-- 答题记录 -->
      <el-menu-item v-if="userInfoRoleRoleId !== editorRoleId" index="/answer-record">
        <el-image class="menu-image" :src="require('@/assets/images/answer-record.png')"></el-image>
        <span slot="title">答題記錄</span>
      </el-menu-item>

      <!-- 学习排行榜 -->
      <el-menu-item v-if="userInfoRoleRoleId !== editorRoleId" index="/learningRankingList">
        <el-image class="menu-image" :src="require('@/assets/images/menu-phb.png')"></el-image>
        <span slot="title">學習排行榜</span>
      </el-menu-item>

      <!-- 学生列表 -->
      <el-menu-item v-if="userInfoRoleRoleId !== editorRoleId" index="/student">
        <el-image class="menu-image" :src="require('@/assets/images/Iconionic-md-people.png')"></el-image>
        <span slot="title">學生列表</span>
      </el-menu-item>

      <!-- 教学内容 -->
      <el-submenu index="1-4">
        <template slot="title">
          <el-image class="menu-image" :src="require('@/assets/images/teaching-menu.png')"></el-image>
          <span slot="title">教學內容</span>
        </template>
        <el-menu-item v-if="userInfoRoleRoleId !== teacherRoleId" index="/evaluate">評估</el-menu-item>
        <el-menu-item v-if="userInfoRoleRoleId !== teacherRoleId" index="/topic">課題</el-menu-item>
        <el-menu-item v-if="userInfoRoleRoleId !== teacherRoleId" index="/practice">練習</el-menu-item>
        <el-menu-item index="/teachingVideo">教學視頻</el-menu-item>
        <el-menu-item v-if="userInfoRoleRoleId !== teacherRoleId" index="/question">題目</el-menu-item>
        <el-menu-item index="/job">佈置作業</el-menu-item>
        <el-menu-item index="/studentJob">學生作業</el-menu-item>
      </el-submenu>

      <!-- 订单 -->
      <el-menu-item v-if="userInfoRoleRoleId == siteAdminRoleId" index="/order">
        <el-image class="menu-image" :src="require('@/assets/images/order-menu.png')"></el-image>
        <span slot="title">訂單</span>
      </el-menu-item>

      <!-- 报告 -->
      <el-menu-item v-if="userInfoRoleRoleId == siteAdminRoleId" index="/report">
        <el-image class="menu-image" :src="require('@/assets/images/report-menu.png')"></el-image>
        <span slot="title">報告</span>
      </el-menu-item>

      <!-- 推广码 -->
      <el-menu-item v-if="userInfoRoleRoleId == siteAdminRoleId" index="/promote">
        <el-image class="menu-image" :src="require('@/assets/images/extension-code-menu.png')"></el-image>
        <span slot="title">推廣碼</span>
      </el-menu-item>

      <!-- 回报问题 -->
      <el-menu-item v-if="userInfoRoleRoleId !== teacherRoleId" index="/returnProblem">
        <el-image class="menu-image" :src="require('@/assets/images/problem-menu.png')"></el-image>
        <span slot="title">回報問題</span>
      </el-menu-item>

      <!-- 分校学生编号表 -->
      <el-menu-item v-if="userInfoRoleRoleId !== teacherRoleId && userInfoRoleRoleId !==editorRoleId" index="/branchStudentNumber">
        <el-image class="menu-image" :src="require('@/assets/images/questionnaire.png')"></el-image>
        <span slot="title">分校學生編號表</span>
      </el-menu-item>

      <!-- 设定 -->
      <el-menu-item v-if="userInfoRoleRoleId == siteAdminRoleId" index="/setting">
        <el-image class="menu-image" :src="require('@/assets/images/material-settings-overscan.png')"></el-image>
        <span slot="title">設定</span>
      </el-menu-item>

      <el-submenu index="cards">
        <template slot="title">
          <el-image class="menu-image" :src="require('@/assets/images/yonghu.png')"></el-image>
          <span slot="title">抽卡管理</span>
        </template>
        <el-menu-item index="/cardNumUser">金幣記錄</el-menu-item>
        <el-menu-item index="/cardUser">中獎記錄</el-menu-item>
        <el-menu-item v-if="userInfoRoleRoleId !== teacherRoleId" index="/coin">金幣獎勵設置</el-menu-item>
        <el-menu-item v-if="userInfoRoleRoleId !== teacherRoleId" index="/card">卡牌商店</el-menu-item>
        <el-menu-item v-if="userInfoRoleRoleId !== teacherRoleId" index="/cardTitle">卡牌系列</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import {logout} from "@/api/security";
import {removeAll, removeToken} from "@/utils/auth";

export default {
  name: 'Menu',
  data() {
    return {
      isCollapsed: false,
      // 权限相关数据，请根据实际情况替换
      userInfoRoleRoleId: 1,
      siteAdminRoleId: 1,
      editorRoleId: 2,
      teacherRoleId: 3,
      adminUserInfoRoleId: 1
    };
  },
  computed: {
    defaultActive() {
      return this.$route.path;
    }
  },
  methods: {
    logout() {
      let d = {
        refreshToken: this.$store.getters.adminUserInfo.refreshToken,
      };
      logout(d).then(() => {
        removeToken();
        removeAll();
        this.$store.dispatch("setAdminUserInfo", null);
        location.reload();
      });
    },
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed;
      this.$emit('update:collapsed', this.isCollapsed);
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar-container {
  height: 100%;
  position: relative;
}

.logo-area {
  padding: 20px 16px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .logo-image {
    width: 32px;
    height: 32px;
    margin-right: 8px;
  }

  .logo-text {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    white-space: nowrap;
  }

  &.collapsed-logo {
    padding: 20px 0;
    justify-content: center;

    .logo-image {
      margin-right: 0;
    }
  }
}

.sidebar {
  height: 100%;
  border-right: none;
  background-color: #fff !important;
  overflow-y: auto;
  overflow-x: hidden;
  // 滾動條美化
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 2px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

.menu-image {
  width: 24px;
  height: 24px;
  margin-right: 12px;
  flex-shrink: 0;
}

.el-menu-item {
  padding: 0 12px;
  height: 48px;
  line-height: 48px;
  border-radius: 8px;

  &.is-active {
    background-color: #f6c98e;
    color: #000;
  }

  &:hover {
    background-color: #f5f5f5;
  }
}

// 折叠样式
.el-menu--collapse {
  .el-menu-item {
    padding: 0;
    justify-content: center;

    .menu-image {
      margin-right: 0;
    }
  }

  .el-submenu {
    .el-submenu__title {
      padding: 0;
      justify-content: center;
      height: 48px;

      .menu-image {
        margin-right: 0;
      }

      span {
        display: none !important;
      }
    }
  }
}

::v-deep {
  .el-submenu__title {
    display: flex;
    align-items: center;
    padding: 0 12px;
    height: 48px;
    line-height: 48px;
    margin: 4px 0px;
    border-radius: 8px;

    .menu-image {
      margin-right: 12px;
    }

    &:hover {
      background-color: #f5f5f5;
    }
  }

  .el-menu--collapse .el-submenu .el-menu {
    display: none;
  }
}
</style>
